module.exports = __webpack_public_path__ + "media/12_27.cc3e5d28.wav";